import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button, Input, Label } from '@ipc/ipc-components';
import {
  getCroColumns,
  getCroData,
  getCroIsLoading,
} from '../redux/selectors/InternalRepatriationsTransactionsSelectors';
import ListTable from '../../../../../common/tables/ListTable';
import TableDefinitions from '../../../../../common/TableDefinitions';
import { getAssetType } from '../../../../../common/asset-types/redux/selectors/AssetTypesSelectors';
import { tableLoadData } from '../../../../../common/tables/actions/ListTableActions';
import { getClickedRowOnTable } from '../../../../../common/tables/reducers/selectors/ListTableSelectors';
import RepatriationsTransactionsHistoryContainer
  from '../../transactions-history/repatriations/containers/RepatriationsTransactionsHistoryContainer';
import CenterInitiatedRepatriationsTransactionsCreate
  from '../create/containers/CenterInitiatedRepatriationsTransactionsCreate';
import DownloadTypes from '../../../../../common/tables/excel/DownloadTypes';
import { TransactionsStyle } from '../../component/Transactions.styles';
import { getUserRole } from '../../../../../common/user/redux/selectors/UserDataSelectors';

class CenterInitiatedRepatriationsTransactionsContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedDayCount: 10,
      showCreateTransactionModal: false,
    };
    this.clickApplyButton = this.clickApplyButton.bind(this);
    this.createCenterInitiatedRepatriation = this.createCenterInitiatedRepatriation.bind(this);
    this.clickApplyButton();
  }

  componentDidUpdate(prevProps) {
    if (this.props.clickedRow !== prevProps.clickedRow) {
      this.clickApplyButton();
    }
  }

  enterPressed = (e) => {
    const code = e.keyCode || e.which;
    if (code === 13) {
      this.clickApplyButton();
    }
  }

  showCreateFormModal = () => {
    this.setState({
      showCreateTransactionModal: true,
    });
  }

  hideCreateFormModal = () => {
    this.setState({
      showCreateTransactionModal: false,
    });
  }

  handleChange(e) {
    this.setState({
      selectedDayCount: e.target.value,
    });
  }

  clickApplyButton() {
    this.props.tableLoadData(
      {
        tableId: TableDefinitions.CENTER_INITIATED_REPATRIATIONS.id,
      },
      this.props.appContext.appContext,
      {
        impcCode: this.props.clickedRow.impc,
        dayCount: this.state.selectedDayCount,
        transactionCode: 'CRO',
      },
    );
  }

  createCenterInitiatedRepatriation() {
    this.setState({
      showCreateTransactionModal: true,
    });
  }

  render() {
    const {
      showCreateTransactionModal,
    } = this.state;
    return (
      <TransactionsStyle>
        <Label>
          Show transactions for the last
          <Input
            className="last-day-input"
            value={this.state.selectedDayCount}
            onChange={(e) => this.handleChange(e)}
            onKeyPress={this.enterPressed}
          />
          days
        </Label>
        <Button className="action-buttons" onClick={this.clickApplyButton}>
          Apply
        </Button>
        {(this.props.userRole.includes('IPC_PALLET_BOX_MANAGER')
          || this.props.userRole.includes('IPC_TRAY_MANAGER')
          || this.props.userRole.includes('IPC_BAG_MANAGER')) && (
          <Button className="action-buttons" onClick={this.createCenterInitiatedRepatriation}>
            Create Center Initiated Repatriation
          </Button>
        )}
        <ListTable
          listId={TableDefinitions.CENTER_INITIATED_REPATRIATIONS.id}
          loading={this.props.isLoading}
          columns={this.props.columns}
          data={this.props.data}
          keyField="id"
          selectCheckbox
          getSubComponentProps={(row) => (
            <div style={{ padding: '20px' }}>
              <RepatriationsTransactionsHistoryContainer
                row={row}
                refreshTransactions={this.clickApplyButton}
              />
            </div>
          )}
          downloadType={DownloadTypes.EXCEL}
        />
        {showCreateTransactionModal && (
          <CenterInitiatedRepatriationsTransactionsCreate
            closeDialog={this.hideCreateFormModal}
            openDialog={this.showCreateFormModal}
            row={this.props.clickedRow}
            refreshTransactions={this.clickApplyButton}
          />
        )}
      </TransactionsStyle>
    );
  }
}

function mapStateToProps(state) {
  return {
    data: getCroData(state),
    columns: getCroColumns(state),
    appContext: getAssetType(state),
    clickedRow: getClickedRowOnTable(state),
    isLoading: getCroIsLoading(state),
    userRole: getUserRole(state),
  };
}

CenterInitiatedRepatriationsTransactionsContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  appContext: PropTypes.objectOf(PropTypes.string),
  tableLoadData: PropTypes.func,
  clickedRow: PropTypes.objectOf(PropTypes.shape),
  isLoading: PropTypes.bool,
  userRole: PropTypes.arrayOf(PropTypes.string),
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
  tableLoadData,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CenterInitiatedRepatriationsTransactionsContainer);
